<aslib-title Text="Parâmetros para Geração de Pagamentos" SubText=" " Icon="fa fas fa-cog"></aslib-title>
<router-outlet></router-outlet>
<br>
<div class="col-md-8">
    <gpa-param-pagamento [modoEdicao]="true"></gpa-param-pagamento>
</div>
<br>


// WEBPACK FOOTER //
// ./src/app/pagamento/adm-pagamento/adm-pagamento.component.html